import { PlannerBase } from '../../planner_base';
import watch   from "redux-watch";
import isEqual from 'is-equal';
import PlannerControllerBase from './base';
export default class BlackOverController extends PlannerControllerBase {
  constructor(tag){
    super(tag);
    this.listenBlackOver();
  }
  listenBlackOver(){
    this.reduxEvent('data.black_over.show',(newVal, oldVal, objectPath) => {
      this.onBlackOver(newVal, oldVal, objectPath);
    })
  }
  // 黒のオーバーフローが表示、または非表示になった
  onBlackOver(isShow, oldVal, projectPath){
    if(isShow){ return; }
    this.updatePlanner({
      orders_planner: {
        selectedCell: null,
        createSchedule: null,
        selectedTasksMemo: null,
        lineMenu: null,
        updateUnder: null,
        updateStatus: null
      }
    });
  }
}
